import { AppFrameContextService } from '@sdbn/common';
import { AppClientConfigurationService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { AbstractStepController, FlowStepHandleResult, HandleResultType, StepControl, WizardServiceLocator } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { DateTime } from 'luxon';

export class TransportPrintIdentityCardController extends AbstractStepController {

    private terminalConnectorUrl: string = null;

    configurationService: AppClientConfigurationService;
    appFrameContextService: AppFrameContextService;
    translationService: TranslationService;
    appServerAPI: AppServerAPI;

    constructor() {
        super();
        this.configurationService = WizardServiceLocator.injector.get(AppClientConfigurationService);
        this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
        this.appFrameContextService = WizardServiceLocator.injector.get(AppFrameContextService);
        this.translationService = WizardServiceLocator.injector.get(TranslationService);
        const terminalHardwareUrl = this.configurationService.getDeviceParameter('terminalhardwareconnector.url');
        if (terminalHardwareUrl != null && terminalHardwareUrl.value.trim().length > 0) {
          this.terminalConnectorUrl = this.configurationService.getDeviceParameter('terminalhardwareconnector.url').value;
        }
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {
      if (this.terminalConnectorUrl == null) {
        console.log('No terminalConnector URL configured. Skip printing');
        this.wizardComponent.next();
      } else {
        this.appServerAPI.execute(this.terminalConnectorUrl + '/io/printer/print', this.buildPrintJobData()).subscribe(result => {
          console.log('print finished');
          this.wizardComponent.next();
        },
        error => {
          console.log('error received');
          this.wizardComponent.next();
        });
      }
    }

    public handleFlow(): FlowStepHandleResult {
      const result = new FlowStepHandleResult();
      result.type = HandleResultType.PROCESSING;
      return result;
    }

    getControls(): StepControl[] {
        return new Array<StepControl>();
    }

    private buildPrintJobData(): any {
      const driver = this.dashboardContext.getContextValue(TerminalContextConstants.driver);
      const carrier = this.dashboardContext.getContextValue(TerminalContextConstants.carrier);
      const supplier = this.dashboardContext.getContextValue(TerminalContextConstants.supplier);
      const orderReference = this.dashboardContext.getContextValue(TerminalContextConstants.orderReference);
      const numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
      const registrationCode = this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode);
      const registrationFinished = this.dashboardContext.getContextValue(TerminalContextConstants.registrationFinished);

      return {
        yardKey: this.appFrameContextService.tenant.value.key,
        type: 'TRANSPORT_IDENTITY_CARD',
        labels: {
          'label.driver': this.translationService.translate('tmc-yard.entity.transport.driver'),
          'label.carrier': this.translationService.translate('tmc-yard.entity.transport.carrier'),
          'label.supplier': this.translationService.translate('tmc-yard.entity.transport.supplier'),
          'label.numberPlate': this.translationService.translate('tmc-yard.entity.transport.numberplate'),
          'label.orderReference': this.translationService.translate('tmc-yard.entity.transport.reference'),
          'label.registrationFinished': this.translationService.translate('tmc-yard.entity.transport.registrationFinished')

        },
        values: {
          driver: driver,
          carrier : carrier,
          supplier: supplier,
          orderReference: orderReference,
          numberPlate: numberPlate,
          registrationFinished: DateTime.fromJSDate(new Date(registrationFinished)).toFormat("dd.MM.yyyy HH:mm"),
          qrCode: registrationCode != null ? 'tmc-yard://transport/' + registrationCode : null
        }
      };
    }
}
